function setCartCookie(cvalue) {
    cvalue = encodeURIComponent(cvalue);
    console.log("[TAILOOR] - set cart cookie: ", cvalue);

    const d = new Date();
    d.setTime(d.getTime() + (15 * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = "cart=" + cvalue + ";" + expires + ";path=/";
}

function getCartCookie() {
    let name = "cart=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var cvalue = c.substring(name.length, c.length)
            return decodeURIComponent(cvalue);
        }
    }
    return null;
}

function getGaClientId() {
    var cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('_ga='));

    if (!cookieValue) return null;

    var gaParts = cookieValue.split('=');
    if (gaParts.length < 2) return null;

    var gaValue = gaParts[1]; // Extract cookie value
    var clientId = gaValue.split('.').slice(2).join('.'); // Extract the Client ID

    console.log("[TAILOOR] - Cookie GA Client ID: ", clientId);

    return clientId || null;
}

function configureGeneric(remote_url, app_id, shop_id, model, language, current_url) {
    console.log("[TAILOOR] - Configure product");

    var cart_id = getCartCookie();
    if (cart_id == null || cart_id == undefined || cart_id == "undefined")
        cart_id = "unknown";

    var token_ga = getGaClientId();

    var request_url = remote_url + "/api/tailoor/" + app_id + "/" + shop_id + "/generate_generic_configure_url";

    var requestBody = {
        cart_token: cart_id,
        token_ga: token_ga,
        model_code: model,
        language: language,
        origin_url: current_url
    };
    
    fetch(request_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
    })
    .then(response => response.json()) 
    .then(json => {
        setCartCookie(json.cart_token);
        window.location = json.configurator_url;
    })
    .catch(err => {
        console.log("[TAILOOR] - Error Response:");
        console.log(err);
    });
}

function configureProduct(remote_url, app_id, shop_id, product_id, language, current_url) {
    console.log("[TAILOOR] - Configure product");

    var cart_id = getCartCookie();
    if (cart_id == null || cart_id == undefined || cart_id == "undefined")
        cart_id = "unknown";

    var token_ga = getGaClientId();

    var request_url = remote_url + "/api/tailoor/" + app_id + "/" + shop_id + "/generate_product_configure_url";

    var requestBody = {
        cart_token: cart_id,
        token_ga: token_ga,
        product_id: product_id,
        language: language,
        origin_url: current_url
    };
    
    fetch(request_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
    })
    .then(response => response.json()) 
    .then(json => {
        setCartCookie(json.cart_token);
        window.location = json.configurator_url;
    })
    .catch(err => {
        console.log("[TAILOOR] - Error Response:");
        console.log(err);
    });
}

function configureRelated(remote_url, app_id, shop_id, product_sku, language, current_url) {
    console.log("[TAILOOR] - Configure product");

    var cart_id = getCartCookie();
    if (cart_id == null || cart_id == undefined || cart_id == "undefined")
        cart_id = "unknown";

    var token_ga = getGaClientId();

    var request_url = remote_url + "/api/tailoor/" + app_id + "/" + shop_id + "/generate_product_configure_url";

    var requestBody = {
        cart_token: cart_id,
        token_ga: token_ga,
        product_sku: product_sku,
        language: language,
        origin_url: current_url
    };
    
    fetch(request_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
    })
    .then(response => response.json()) 
    .then(json => {
        setCartCookie(json.cart_token);
        window.location = json.configurator_url;
    })
    .catch(err => {
        console.log("[TAILOOR] - Error Response:");
        console.log(err);
    });
}